(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wy-page-detail", [], factory);
	else if(typeof exports === 'object')
		exports["wy-page-detail"] = factory();
	else
		root["wy-page-detail"] = factory();
})(window, function() {
return 